import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import zh_CN from "../../locales/zh-CN";
import en_US from "../../locales/en-US";
import vi_VN from "../../locales/vi-VN";
import zh_TW from "../../locales/zh-TW";
import ja_JP from "../../locales/ja-JP";
import ko_KR from "../../locales/ko-KR";
import { IntlProvider, addLocaleData } from "react-intl";
import zh from "react-intl/locale-data/zh";
import en from "react-intl/locale-data/en";
import vi from "react-intl/locale-data/vi";
import ja from "react-intl/locale-data/ja";
import ko from "react-intl/locale-data/ko";
import { getQueryString } from "../../utils";
import store from "store";
addLocaleData([...zh, ...en, ...vi, ...ja, ...ko]);

const BasicLayout = (props) => {
  const [locale] = useState(props.match.params.lang || "en-US");

  function getMessage(message) {
    message = message.toLowerCase();
    let returnMsg;
    switch (message) {
      case "zh-cn":
        returnMsg = zh_CN;
        break;
      case "en-us":
        returnMsg = en_US;
        break;
      case "vi-vn":
        returnMsg = vi_VN;
        break;
      case "zh-tw":
        returnMsg = zh_TW;
        break;
      case "ja-jp":
        returnMsg = ja_JP;
        break;
      case "ko-kr":
        returnMsg = ko_KR;
        break;
    }
    return returnMsg;
  }

  return (
    <IntlProvider locale={locale.split("_")[0]} messages={getMessage(locale)}>
      {props.children}
    </IntlProvider>
  );
};

export default withRouter(BasicLayout);



// WEBPACK FOOTER //
// ./src/components/layouts/index.js